/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 */
// https://davidwalsh.name/javascript-debounce-function
function debounce(func: any, wait: number, immediate: boolean = false) {
	let timeout: any;
	return function(this: any) {
        const context: any = this;
        const args = arguments;
        // tslint:disable-next-line:only-arrow-functions
		const later = function() {
			timeout = null;
			if (!immediate) {
                func.apply(context, args);
            }
		};
		const callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) {
            func.apply(context, args);
        }
	};
};

export { debounce };
export default debounce;



// WEBPACK FOOTER //
// ./src/helpers/debounce.ts